import { Icon } from 'components/Icon/Icon';
import { BodySmall } from 'components/Text/BodySmall';
import { legacySpace } from 'theme/theme';

import { DropBox } from './DropBox';

type Props = {
  id?: string;
  message?: string;
};

export function ImagePickerButton({ id, message }: Props) {
  return (
    <DropBox id={id} position="relative" borderRadius="8px" m={legacySpace[3]}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '6px 16px',
        }}
      >
        <div>
          <Icon name="upload" size={23} />
        </div>

        <BodySmall my={0} ml="8px" lineHeight={1.375}>
          {message}
        </BodySmall>
      </div>
    </DropBox>
  );
}
